import { useContext } from 'react';
import { SettingsContext, SettingsContextType } from '../contexts/SettingsContext';

/**
 * Poskytuje přístup k centrálnímu stavu a funkcím pro správu nastavení (štítky, kategorie atd.).
 * Musí být použit uvnitř komponenty, která je obalena v `SettingsProvider`.
 */
export const useSettings = (): SettingsContextType => {
    const context = useContext(SettingsContext);
    if (context === undefined) {
        throw new Error('Hook useSettings musí být použit uvnitř SettingsProvider');
    }
    return context;
};
